var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CountryFlag',{attrs:{"country":_vm.getFlagName(_vm.lang),"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }